
/*!
 * @pendo/components 3.25.3
 * (c) 2018-present
 */

import 'lodash/isEqual';
import 'just-kebab-case';
import { P as PendoAnalytics } from './labels-mixin.js';
import 'focus-visible/dist/focus-visible.js';
import './_rollupPluginBabelHelpers-mixin.js';
import 'lodash/kebabCase';
import 'feather-icons';
import PendoIcon from './pendo-icon.js';
import 'vue';
import 'lodash/get';
import './pendo-loading-mixin.js';
import PendoLoadingIndicator from './pendo-loading-indicator.js';

const THEME_CLASSES_MAP = {
  dark: 'p2-dark',
  'p2-dark': 'p2-dark',
  p2: 'p2-light',
  'p2-light': 'p2-light',
  app: 'app',
  via: 'via'
};
var script = {
  name: 'PendoButton',
  components: {
    PendoIcon,
    PendoLoadingIndicator
  },
  directives: {
    PendoAnalytics
  },
  inject: {
    elForm: {
      default: ''
    }
  },
  props: {
    type: {
      type: String,
      default: 'primary',
      validator: value => ['primary', 'secondary', 'tertiary', 'link', 'danger'].includes(value)
    },
    theme: {
      type: String,
      default: 'p2-light',
      validator: theme => ['app', 'dark', 'p2', 'p2-light', 'p2-dark', 'via'].includes(theme)
    },
    size: {
      type: String,
      default: 'medium',
      validator: size => ['mini', 'small', 'medium'].includes(size)
    },
    label: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: null
    },
    prefixIcon: {
      type: String,
      default: ''
    },
    suffixIcon: {
      type: String,
      default: ''
    },
    iconSize: {
      type: [String, Number],
      default: '14'
    },
    block: {
      type: Boolean,
      default: false
    },
    nativeType: {
      type: String,
      default: 'button'
    },
    loading: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    buttonClass() {
      return ['pendo-button', `pendo-button--${this.type}`, `pendo-button--${this.size}`, `${THEME_CLASSES_MAP[this.theme]}`, {
        'is-disabled': this.buttonDisabled,
        'is-loading': this.loading,
        'is-outline': this.outline,
        'is-block': this.block,
        'is-icon-only': this.isIconOnly,
        'has-prefix-icon': !this.isIconOnly && this.showPrefixIcon,
        'has-suffix-icon': this.showSuffixIcon
      }];
    },

    buttonDisabled() {
      return this.loading || this.disabled || (this.elForm || {}).disabled;
    },

    isIconOnly() {
      return !this.$slots.default && !this.label && !!this.icon;
    },

    showSuffixIcon() {
      if (this.loading) {
        return false;
      }

      return Boolean(this.suffixIcon);
    },

    showPrefixIcon() {
      if (this.loading) {
        return false;
      }

      return Boolean(this.icon || this.prefixIcon);
    }

  }
};

const __vue_script__ = script;

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('button', _vm._g({
    directives: [{
      name: "pendo-analytics",
      rawName: "v-pendo-analytics",
      value: {
        type: 'components:button',
        value: _vm.isIconOnly ? _vm.icon : _vm.label
      },
      expression: "{ type: 'components:button', value: isIconOnly ? icon : label }"
    }],
    class: _vm.buttonClass,
    attrs: {
      "disabled": _vm.buttonDisabled,
      "aria-disabled": String(_vm.buttonDisabled),
      "autofocus": _vm.autofocus,
      "type": _vm.nativeType
    }
  }, _vm.$listeners), [_vm.loading ? _c('pendo-loading-indicator', {
    attrs: {
      "spinner-props": {
        color: false,
        size: _vm.iconSize
      },
      "loading": _vm.loading,
      "type": _vm.theme === 'via' ? 'feather' : 'material',
      "button": ""
    }
  }) : _vm._e(), _vm._v(" "), _vm.showPrefixIcon ? _c('pendo-icon', {
    class: {
      'icon-prefix': !_vm.isIconOnly
    },
    attrs: {
      "type": _vm.icon || _vm.prefixIcon,
      "size": _vm.iconSize,
      "stroke-width": 2.5
    }
  }) : _vm._e(), _vm._v(" "), _c('span', [_vm._t("default", [_vm._v("\n            " + _vm._s(_vm.label) + "\n        ")])], 2), _vm._v(" "), _vm.showSuffixIcon ? _c('pendo-icon', {
    staticClass: "icon-suffix",
    attrs: {
      "type": _vm.icon || _vm.suffixIcon,
      "size": _vm.iconSize,
      "stroke-width": 2.5
    }
  }) : _vm._e()], 1);
};

var __vue_staticRenderFns__ = [];
const __vue_inject_styles__ = undefined;
const __vue_scope_id__ = undefined;
const __vue_is_functional_template__ = false;

function __vue_normalize__(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "pendo-button.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var PendoButton = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__);

export default PendoButton;
